import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { Store } from "@ngrx/store";
import { IAppState } from "../store/states/app";
import {
  selectIsAuthenticated,
  selectIsAuthenticating,
  selectRegistrationCompleted,
} from "../store/selectors";
import { combineLatest, Observable } from "rxjs";
import { ROUTES_CONFIG } from "../config";
@Injectable({ providedIn: "root" })
export default class RegistrationCompleteGuard implements CanActivate {
  /**
   *
   * @param router
   * @param _store
   */
  constructor(
    private router: Router,
    private _store: Store<IAppState>,
  ) {
    //
  }

  /**
   *
   * @param route
   * @param state
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | boolean {
    return new Observable<boolean>((observer) => {
      combineLatest(
        this._store.select(selectIsAuthenticated),
        this._store.select(selectIsAuthenticating),
        this._store.select(selectRegistrationCompleted),
      ).subscribe(([authenticated, authenticating, registrationCompleted]) => {
        authenticated
          ? registrationCompleted
            ? (this.router.navigate(["/"]), observer.next(false))
            : observer.next(true)
          : this.router.navigate(["/"]),
          observer.next(false);
      });
    });
  }
}
